export {} from './illustrations';

export {} from './messages';

export {} from './ShortcutTile';

export {} from './PersonalizationModal';

export {} from './PersonalizationButton';

import ShortcutsWidget from './ShortcutsWidget';
export default ShortcutsWidget;
